import style from './P2PCommission.css';
import useTranslation from '../../../localization/i18n.context';

// ATTENTION: Currently the commission is Free but we prepared this to manage dynamic values in the future.
//  Maybe this component will change in the future
export default function P2PCommission({ className = '', commission }) {
  const { t, getCurrency } = useTranslation();

  return (
    <div className={`${className} ${style.container}`}>
      {commission.value === 0
        ? t('Free commission')
        : `{commission} commission`.replace(
            '{commission}',
            `${
              commission.type === 'FIXED'
                ? getCurrency(commission.currency)
                : ''
            }${commission.value} ${
              commission.type === 'PERCENTAGE' ? '%' : ''
            }`,
          )}
    </div>
  );
}
